import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { AuthService } from "@app/auth/services/authentication/auth.service";
import { SidebarService } from "@app/shared/services/sidebar/sidebar.service";
import { TextService } from "@app-shared/services/text/text.service";

@Component({
  selector: "app-not-found",
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: "./not-found.component.html",
  styleUrl: "./not-found.component.scss",
})
export class NotFoundComponent {
  public sidebar = inject(SidebarService);

  getContentStyles() {
    return {
      "margin-left": this.sidebar.getSidebarState() ? " 140px" : "400px",
      transition: " margin-left 0.3s cubic-bezier(0, 0, 0, 1.08) 0s ",
    };
  }
  constructor(
    public textService: TextService,
    private route: ActivatedRoute,
    private auth: AuthService
  ) {
    this.isLoggedIn = this.auth.isLoggedIn();
  }

  isLoggedIn = false;

  currentRoute: string = this.route.snapshot.url[0].path;

  text = {
    notFound: this.textService.labels.general.notFound,
    notFoundTitle: this.textService.labels.general.notFoundTitle,
    backToHome: this.textService.labels.general.backToHome,
  };
}
